<section class="playground">
  <h2 class="playground__heading">Checkbox list</h2>
  <p class="playground__hint">
    <code>common-checkbox-list</code> — título + lista de checkboxes (single/multiple) y layout rows/columns.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>titleKey (i18n)</span>
        <input type="text" [(ngModel)]="titleKey" placeholder="Ej. uiKitExamples.checkboxList.title" />
      </label>

      <label class="playground__field">
        <span>checkboxType</span>
        <select [(ngModel)]="checkboxType">
          <option *ngFor="let t of checkboxTypes" [value]="t">{{ t }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>selectionMode</span>
        <select [(ngModel)]="selectionMode">
          <option *ngFor="let m of selectionModes" [value]="m">{{ m }}</option>
        </select>
      </label>

      <label class="playground__field">
        <span>layout</span>
        <select [(ngModel)]="layout">
          <option *ngFor="let l of layouts" [value]="l">{{ l }}</option>
        </select>
      </label>

      <label class="playground__field" *ngIf="layout === 'columns'">
        <span>columns</span>
        <input type="number" [(ngModel)]="columns" min="1" max="4" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>

      <div class="playground__preview-box">
        <common-checkbox-list
          [titleKey]="titleKey"
          [options]="options"
          [checkboxType]="checkboxType"
          [selectionMode]="selectionMode"
          [layout]="layout"
          [columns]="columns"
          [disabled]="disabled"
          [value]="value"
          [values]="values"
          (selectionChange)="onSelectionChange($event)"
        ></common-checkbox-list>
      </div>

      <p class="playground__meta">
        value: <strong>{{ value }}</strong>
      </p>
      <p class="playground__meta">
        values: <strong>{{ values | json }}</strong>
      </p>
      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>

